import { Link, useLocation } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import brand from "../brand";
import "./NavLottery.css";

const links = [
  { to: "/", label: "Home" },
  { to: "/onepmresult", label: "1 PM Result" },
  { to: "/eightpmresult", label: "8 PM Result" },
  { to: "/todayresult", label: "Today" },
  { to: "/oldresult", label: "History" },
];

function NavbarLottery() {
  const location = useLocation();

  return (
    <Navbar expand="lg" className="premium-nav" sticky="top">
      <Container>
        <Navbar.Brand as={Link} to="/" className="brand-link">
          <span className="brand-mark">SL</span>
          <span>{brand.name}</span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="main-navbar" />
        <Navbar.Collapse id="main-navbar">
          <Nav className="ms-auto align-items-lg-center">
            {links.map((link) => (
              <Nav.Link
                key={link.to}
                as={Link}
                to={link.to}
                className={location.pathname.toLowerCase() === link.to.toLowerCase() ? "active" : ""}
              >
                {link.label}
              </Nav.Link>
            ))}
            {/* <a className="telegram-link" href={brand.telegramUrl} target="_blank" rel="noreferrer">
              Telegram
            </a> */}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavbarLottery;
